process.env.API_SERVER = 'https://relevant.community';
// process.env.API_SERVER = 'http://localhost:3000';
// process.env.API_SERVER = 'http://192.168.1.167:3000';
process.env.TOKEN_ADDRESS = '0xb6c4267C4877BB0D6b1685Cfd85b0FBe82F105ec';
process.env.TWITTER_COMSUMER_KEY = '5kfwS2t05aNKoZnOEXjFVLzMn';
process.env.TWITTER_CONSUMER_SECRET =
  '8DJKNiyvJJidPkFeANMU8ybkULMkTOssQoFW5vFhK2GQ7mVqhP';
process.env.RECAPTCHA_KEY = '6LeyI8EZAAAAAN4S0f9BaSOf7Hks5xTR7CebrgsG';
//
